module.exports = __webpack_public_path__ + "img/img10.56e62b14.png";